import { useRef, useState } from "react";
import { ContentCopy as CopyIcon } from "@mui/icons-material";
import { Paper, Popper, Typography, IconButton } from "@mui/material";

const CopyToClipboard = ({ value }) => {
  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleCopy = async (e) => {
    e.stopPropagation();

    await navigator.clipboard.writeText(String(value ?? ""));

    setOpen(true);

    setTimeout(() => {
      setOpen(false);
    }, 1500);
  };

  if (!value) {
    return null;
  }

  return (
    <>
      <IconButton
        ref={anchorRef}
        size="small"
        onClick={handleCopy}
        sx={{
          cursor: "pointer",
          padding: "2px",
          fontSize: "14px",
          "&:hover": {
            color: "#94BA33",
          },
          color: "inherit",
        }}
      >
        <CopyIcon fontSize="inherit" />
      </IconButton>

      <Popper
        open={open}
        anchorEl={anchorRef.current}
        placement="right-start"
        sx={{ zIndex: 99999, pointerEvents: "none" }}
      >
        <Paper sx={{ px: 1, py: 0.5 }}>
          <Typography variant="caption">Copied!</Typography>
        </Paper>
      </Popper>
    </>
  );
};

export default CopyToClipboard;
